import { IPropertyInfoMetadata } from "../../DotNet/SeriouslyRAD.Framework/Reflection/IPropertyInfoMetadata";
import { ITypeInfoMetadata } from "../../DotNet/SeriouslyRAD.Framework/Reflection/ITypeInfoMetadata";
import { EntityBaseProperties, IEntityBaseProperties } from "./BaseTypes/EntityBaseProperties";
import { ISoftDeletableEntityProperties, SoftDeletableEntityProperties } from "./BaseTypes/SoftDeletableEntityProperties";

export interface ILookupItemProperties extends IEntityBaseProperties, ISoftDeletableEntityProperties
{

    // #region Basic Properties

    typeLookupItemId: IPropertyInfoMetadata;
    order: IPropertyInfoMetadata;
    description: IPropertyInfoMetadata;
    isLinkedToEnum: IPropertyInfoMetadata;

    // #endregion

    // #region Navigation Properties

    typeLookupItem: IPropertyInfoMetadata;

    // #endregion

    // #region Navigation Collection Properties

    lookupItemsByType: IPropertyInfoMetadata;
    teamMembersByType: IPropertyInfoMetadata;
    userSettingTypesByDataType: IPropertyInfoMetadata;

    // #endregion

}

export const LookupItem: ITypeInfoMetadata<ILookupItemProperties> = {
    attributes: [
        {
            id: "{3433134C-22E8-4576-BE0C-3B84BE5DFC8A}",
            $type: "SeriouslyRAD.Framework.ClientAwareIdAttribute, SeriouslyRAD.Framework"
        },
        {
            name: "LookupItem",
            nameFriendly: "Lookup Item",
            namePlural: "LookupItems",
            namePluralFriendly: "Lookup Items",
            $type: "SeriouslyRAD.Framework.ClientAwareNameAttribute, SeriouslyRAD.Framework"
        }
    ],
    classHierarchy: [
        "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
        "SeriouslyRAD.Framework.Data.EntityBase, SeriouslyRAD.Framework.Data.Entities",
        "System.Object, System.Private.CoreLib"
    ],
    hasEnumFlags: false,
    name: "LookupItem",
    properties: {
        ...EntityBaseProperties,
        ...SoftDeletableEntityProperties,
        typeLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Type"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Type"
                },
                {
                    foreignEntityAlias: "LookupItemsByType",
                    typeDescription: "",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 0
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "TypeLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        order: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Order"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[SeriouslyRAD.Framework.Data.Entities.LookupItem+OrderMandatoryEvaluatorAttributeType, SeriouslyRAD.Framework.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 1
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "Order",
            propertyTypeId: "System.Nullable`1[[System.Int32, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        description: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Description"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Description"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[SeriouslyRAD.Framework.Data.Entities.LookupItem+DescriptionMandatoryEvaluatorAttributeType, SeriouslyRAD.Framework.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 2
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "Description",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        isLinkedToEnum: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Is Linked to Enum"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 3
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "IsLinkedToEnum",
            propertyTypeId: "System.Nullable`1[[System.Boolean, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        lookupItemsByType: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "LookupItemsByType",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Interception.EntityBaseHashSet`1[[SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities]], SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        teamMembersByType: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "TeamMembersByType",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Interception.EntityBaseHashSet`1[[SeriouslyRAD.Framework.Data.Entities.TeamMember, SeriouslyRAD.Framework.Data.Entities]], SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        typeLookupItem: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "TypeLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        userSettingTypesByDataType: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "UserSettingTypesByDataType",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Interception.EntityBaseHashSet`1[[SeriouslyRAD.Framework.Data.Entities.UserSettingType, SeriouslyRAD.Framework.Data.Entities]], SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        }
    },
    underlyingTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
    $type: "SeriouslyRAD.Framework.Reflection.TypeInfoMetadata, SeriouslyRAD.Framework"
};

